import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
} from './dossier-workflow.action';

import {
    fetchSingleRecord as WFetchSingleRecord,
    fetchSingleRecordSuccess as WFetchSingleRecordSuccess,
    fetchSingleRecordFail as WFetchSingleRecordFail,
} from '../Workflows/workflows.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DossierWorkflowTableService } from './dossier-workflow-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { ResponseService } from '../response/response-service.model';


@Injectable()
export class DossierWorkflowRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data: any) => {
                const url = 'dossier/'+data.dossierId+'/dossier-workflow';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        this.moduleTableService.workflow = data.workflow;

                        this.store.dispatch(WFetchSingleRecordSuccess({singleData: data.workflow, steps: []}));

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: DossierWorkflowTableService,
        private tableService: DatatableService,
    ) { }

}